import * as React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { openReviewsGoToAppModal } from 'shared/actions/reviewsGoToAppModal';
import { CardSectionNew } from 'shared/components/CardSectionNew';
import { ReviewsSnippet, ReviewsEmptySnippet } from 'shared/components/ReviewsSnippet';
import { reviewsElementId } from 'shared/constants/reviews';
import { useDailyRentReviews } from 'shared/hooks/useReviewsMiniWidget';
import { selectOfferId } from 'shared/selectors';
import { selectDailyrentOfferRating } from 'shared/selectors/offerData/selectDailyrentOfferRating';

import { extractNumber, trackGoToReviewsPage } from './utils';

export function ReviewsSnippetContainer() {
  const dispatch = useDispatch();
  const objectId = useSelector(selectOfferId);
  const offerRating = useSelector(selectDailyrentOfferRating);
  const { isReviewsEnabled } = useDailyRentReviews();

  const [reviewsLink, setReviewsLink] = React.useState('');

  React.useEffect(() => {
    const link = window.location.href + 'reviews/';
    setReviewsLink(link);
  }, []);

  const onClick = React.useCallback(() => {
    dispatch(openReviewsGoToAppModal());
  }, [dispatch]);

  const onShowAllReviewsButtonClick = React.useCallback(() => {
    const rating = offerRating?.rating ? extractNumber(offerRating?.rating) : -1;
    const reviewsCount = offerRating?.reviewsCount ? extractNumber(offerRating?.reviewsCount) : -1;

    trackGoToReviewsPage({ objectId, rating, reviewsCount });
  }, [objectId, offerRating]);

  if (!isReviewsEnabled) {
    return null;
  }

  if (!offerRating?.rating && !offerRating?.reviewsCount) {
    return (
      <CardSectionNew>
        <ReviewsEmptySnippet elementId={reviewsElementId} onWriteButtonClick={onClick} />
      </CardSectionNew>
    );
  }

  return (
    <CardSectionNew>
      <ReviewsSnippet
        elementId={reviewsElementId}
        rating={offerRating?.rating}
        reviewsCount={offerRating?.reviewsCount}
        reviewsLink={reviewsLink}
        scores={offerRating?.scores}
        onAllButtonClick={onShowAllReviewsButtonClick}
        onWriteButtonClick={onClick}
      />
    </CardSectionNew>
  );
}
